export default "__VITE_ASSET__BAvLakp4__"